import { createEntityWithDefaults } from "actions/entities";
import { fetchEntities, filterEntities } from 'actions/entities';
import EntitiesMenu from 'components/entities/EntitiesMenu';
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getConsultationReminders } from "../../selectors/consultation_reminders";
import { getCurrentOffice } from "../../selectors/offices";
import ConsultationReminderForm from "./ConsultationReminderForm";

const mapStateToProps = (state, ownProps) => {


  return {
   entities: getConsultationReminders(state),
   entityName: 'consultationReminder',
    form: ConsultationReminderForm,
   item: (props) => <div>{I18n.t(`api.forms.consultation_reminder.options.${props.consultationReminder?.minutesNotice}`)}</div>,
   loading: state.meta?.consultationReminder?.loading,
    error: state.meta?.consultationReminder?.error
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEntities: () => {
      dispatch(fetchEntities('consultationReminders'))
    },
    filterEntities: (filter) => {
      dispatch(filterEntities('consultationReminders', filter))
    },
    createEntityWithDefaults: () => {
      const office = dispatch( (dispatch, getState) => { return getCurrentOffice(getState())})
      const templateBody = I18n.t('api.consultation_reminders.default_reminder_template', {office: office.name})
      const subject =  I18n.t('api.consultation_reminders.default_reminder_subject')

      let templateId = dispatch(createEntityWithDefaults('emailTemplate', {emailType: 'consultation_reminder', subject: subject, body: templateBody}))
      return  dispatch(createEntityWithDefaults('consultationReminder', { emailTemplateId: templateId }))
    },
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EntitiesMenu));
